(function () {
  if (window.initKlaviyoDelayedForm) return;
  window._umKlaviyoInitQueue = window._umKlaviyoInitQueue || [];
  window.dataLayer = window.dataLayer || [];

  /*
   * HOLDOUT EXPERIMENT DISABLED.
   * Kept commented out so the previous assignment, attribution, GA4 and cart
   * instrumentation can be restored if the experiment is needed again.
   * Desktop popup suppression now happens in initKlaviyoDelayedForm below.
   *
  var EXPERIMENT_NAME = 'popup_fd_2026_hiintent_desktop_v1';
  var EXPERIMENT_SPLIT = 0.5;
  var EXPERIMENT_DAYS = 60;
  var EXPERIMENT_CONTEXT_KEY = 'popup_experiment_context_' + EXPERIMENT_NAME;
  var CART_ATTRIBUTE_KEY = 'popup_fd_2026_hiintent_desktop_v1';
  var SEARCH_ENGINE_HOSTS = [
    'google.',
    'bing.com',
    'search.yahoo.com',
    'duckduckgo.com',
    'ecosia.org',
    'yandex.',
    'baidu.com',
    'aol.com',
    'ask.com',
    'naver.com',
    'seznam.cz'
  ];
  var SEARCH_UTM_SOURCES = {
    google: true,
    bing: true,
    yahoo: true,
    duckduckgo: true,
    ecosia: true,
    yandex: true,
    baidu: true,
    aol: true,
    ask: true
  };
  var GOOGLE_PAID_MEDIUMS = {
    cpc: true,
    ppc: true,
    sem: true,
    paidsearch: true,
    'paid-search': true,
    display: true,
    shopping: true
  };
  var EMAIL_MEDIUMS = {
    email: true,
    'e-mail': true,
    newsletter: true,
    edm: true
  };
  var EMAIL_SOURCES = {
    email: true,
    klaviyo: true,
    mailchimp: true
  };
  var SOCIAL_UTM_SOURCES = {
    facebook: true,
    instagram: true,
    meta: true,
    fb: true,
    ig: true,
    tiktok: true,
    twitter: true,
    x: true,
    pinterest: true,
    snapchat: true,
    linkedin: true,
    reddit: true
  };
  var SOCIAL_REFERRER_HOSTS = [
    'facebook.com',
    'instagram.com',
    'tiktok.com',
    'twitter.com',
    'x.com',
    'pinterest.com',
    'snapchat.com',
    'linkedin.com',
    'lnkd.in',
    'reddit.com'
  ];
  var SOCIAL_CLICK_IDS = [
    'fbclid',
    'ttclid',
    'twclid',
    'li_fat_id',
    'epik'
  ];
  var OTHER_PAID_CLICK_IDS = [
    'msclkid'
  ];

  function now() {
    return Date.now();
  }

  function setCookie(name, value, days) {
    var expires = new Date(now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var prefix = name + '=';
    var row = document.cookie
      .split('; ')
      .find(function (cookieRow) {
        return cookieRow.indexOf(prefix) === 0;
      });
    if (!row) return '';
    return row.substring(prefix.length);
  }

  function readJson(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeContext(context) {
    var serialized = JSON.stringify(context);
    try {
      localStorage.setItem(EXPERIMENT_CONTEXT_KEY, serialized);
    } catch (e) {
      // localStorage may be blocked
    }
    try {
      setCookie(EXPERIMENT_CONTEXT_KEY, serialized, EXPERIMENT_DAYS);
    } catch (e) {
      // cookie write may fail
    }
  }

  function clearContext() {
    try {
      localStorage.removeItem(EXPERIMENT_CONTEXT_KEY);
    } catch (e) {
      // ignore
    }
    try {
      document.cookie = EXPERIMENT_CONTEXT_KEY + '=; Max-Age=0; path=/; SameSite=Lax';
    } catch (e) {
      // ignore
    }
  }

  function readStoredContext() {
    var localRaw = '';
    try {
      localRaw = localStorage.getItem(EXPERIMENT_CONTEXT_KEY) || '';
    } catch (e) {
      localRaw = '';
    }
    var context = readJson(localRaw);

    if (!context) {
      var cookieRaw = '';
      try {
        cookieRaw = decodeURIComponent(getCookie(EXPERIMENT_CONTEXT_KEY) || '');
      } catch (e) {
        cookieRaw = '';
      }
      context = readJson(cookieRaw);
    }
    if (!context) return null;

    if (context.name !== EXPERIMENT_NAME) {
      clearContext();
      return null;
    }

    if (!Number.isFinite(context.expiresAt) || context.expiresAt <= now()) {
      clearContext();
      return null;
    }

    return context;
  }

  function getReferrerHost() {
    try {
      return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    } catch (e) {
      return '';
    }
  }

  function isDesktopViewport() {
    if (!window.matchMedia) return true;
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function hasAnyUtm(params) {
    return !!(
      params.get('utm_source') ||
      params.get('utm_medium') ||
      params.get('utm_campaign')
    );
  }

  function hasAnyQueryParam(params, keys) {
    return keys.some(function (key) {
      return params.has(key);
    });
  }

  function hostIncludesAny(host, domainFragments) {
    if (!host) return false;
    return domainFragments.some(function (fragment) {
      return host.indexOf(fragment) !== -1;
    });
  }

  function classifyLandingTraffic() {
    var params = new URLSearchParams(window.location.search || '');
    var utmSource = (params.get('utm_source') || '').trim().toLowerCase();
    var utmMedium = (params.get('utm_medium') || '').trim().toLowerCase();
    var utmCampaign = (params.get('utm_campaign') || '').trim().toLowerCase();
    var hasGoogleClickId = params.has('gclid') || params.has('gbraid') || params.has('wbraid');
    var hasSocialClickId = hasAnyQueryParam(params, SOCIAL_CLICK_IDS);
    var hasOtherPaidClickId = hasAnyQueryParam(params, OTHER_PAID_CLICK_IDS);
    var referrerHost = getReferrerHost();
    var isSearchReferrer = !!referrerHost && SEARCH_ENGINE_HOSTS.some(function (domain) {
      return referrerHost.indexOf(domain) !== -1;
    });
    var isSearchOrganicUtm = !!SEARCH_UTM_SOURCES[utmSource] && (utmMedium === 'organic' || utmMedium === 'seo' || utmMedium === 'search');
    var hasPaidGoogleUtm = utmSource === 'google' && !!GOOGLE_PAID_MEDIUMS[utmMedium];
    var isEmailTraffic = !!EMAIL_MEDIUMS[utmMedium] || !!EMAIL_SOURCES[utmSource] || /newsletter|email/.test(utmCampaign);
    var isSocialTraffic = !!SOCIAL_UTM_SOURCES[utmSource] || hasSocialClickId || hostIncludesAny(referrerHost, SOCIAL_REFERRER_HOSTS);
    var isDirect = !referrerHost && !hasAnyUtm(params) && !hasGoogleClickId && !hasSocialClickId && !hasOtherPaidClickId;
    var isDesktop = isDesktopViewport();

    if (!isDesktop) {
      if (isDirect) {
        return {
          eligible: true,
          detectedChannel: 'direct',
          segment: 'mobile_direct',
          reason: ''
        };
      }
      return {
        eligible: false,
        detectedChannel: isSocialTraffic ? 'social' : (utmSource || (referrerHost ? 'non_target_referrer' : 'mobile')),
        reason: 'mobile_non_direct'
      };
    }

    if (isSocialTraffic) {
      return {
        eligible: false,
        detectedChannel: 'social',
        reason: 'desktop_non_target_channel'
      };
    }

    if (hasGoogleClickId || hasPaidGoogleUtm) {
      return {
        eligible: true,
        detectedChannel: 'google_ads',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    if (isEmailTraffic) {
      return {
        eligible: true,
        detectedChannel: 'email',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    if (isDirect) {
      return {
        eligible: true,
        detectedChannel: 'direct',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    if ((isSearchReferrer || isSearchOrganicUtm) && !hasGoogleClickId && !hasOtherPaidClickId && !hasPaidGoogleUtm && !isEmailTraffic) {
      return {
        eligible: true,
        detectedChannel: 'organic',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    var reason = 'desktop_non_target_channel';
    if (!referrerHost && !utmSource && !utmMedium && utmCampaign) {
      reason = 'unknown_channel';
    }

    return {
      eligible: false,
      detectedChannel: referrerHost ? 'non_target_referrer' : (utmSource || 'unknown'),
      reason: reason
    };
  }

  function createExperimentContext(classification) {
    var source = classification || classifyLandingTraffic();
    var context = {
      name: EXPERIMENT_NAME,
      createdAt: now(),
      expiresAt: now() + (EXPERIMENT_DAYS * 864e5),
      eligible: source.eligible === true,
      detectedChannel: source.detectedChannel || 'unknown',
      segment: source.segment || '',
      reason: source.reason || '',
      variant: null
    };

    if (context.eligible) {
      context.variant = Math.random() < EXPERIMENT_SPLIT ? 'holdout' : 'show';
    }

    return context;
  }

  function getExperimentContext() {
    var stored = readStoredContext();
    if (stored) return stored;

    // Only persist when the visitor qualifies for this experiment cohort.
    // Non-eligible traffic is evaluated per landing so users can still enter
    // the test later from a qualifying desktop high-intent arrival.
    var classification = classifyLandingTraffic();
    var created = createExperimentContext(classification);
    if (created.eligible) {
      writeContext(created);
    }
    return created;
  }

  var experimentContext = getExperimentContext();
  if (experimentContext.eligible) {
    window.popupExperiment = {
      name: experimentContext.name,
      variant: experimentContext.variant,
      channel: experimentContext.detectedChannel,
      segment: experimentContext.segment || '',
      eligible: true
    };
  } else {
    try {
      delete window.popupExperiment;
    } catch (e) {
      window.popupExperiment = undefined;
    }
  }

  var eventSeen = window.__umPopupExperimentEventSeen || (window.__umPopupExperimentEventSeen = {});
  function pushDataLayer(eventName, payload, dedupeKey) {
    if (!eventName) return;
    if (dedupeKey && eventSeen[dedupeKey]) return;
    var data = Object.assign({ event: eventName }, payload || {});
    window.dataLayer.push(data);
    if (dedupeKey) eventSeen[dedupeKey] = true;
  }

  function getLifecycleExperimentPayload(context) {
    if (context && context.eligible) {
      return {
        experiment_name: context.name,
        experiment_variant: context.variant,
        popup_eligible_segment: context.segment || 'eligible'
      };
    }
    return {
      popup_eligible_segment: 'ineligible'
    };
  }

  function isPopupExperimentDebugEnabled() {
    try {
      if (window.__umPopupExperimentDebug === true) return true;
      if (window.location && /(?:\?|&)um_popup_debug=1(?:&|$)/.test(window.location.search || '')) return true;
      return localStorage.getItem('um_popup_debug') === '1';
    } catch (e) {
      return window.__umPopupExperimentDebug === true;
    }
  }

  function popupExperimentDebug(stage, detail) {
    if (!isPopupExperimentDebugEnabled()) return;
    var payload = {
      at: new Date().toISOString(),
      stage: stage || 'debug',
      detail: detail || {}
    };
    window.__umPopupExperimentDebugLog = window.__umPopupExperimentDebugLog || [];
    window.__umPopupExperimentDebugLog.push(payload);
    if (window.__umPopupExperimentDebugLog.length > 200) {
      window.__umPopupExperimentDebugLog.shift();
    }
    if (window.console && typeof console.log === 'function') {
      console.log('[UM Popup Experiment]', payload);
    }
  }

  function getFetchDebugUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartDebugRequest(url) {
    return /\/cart(?:\/|\.js|\/update\.js|\/change\.js)/.test(String(url || ''));
  }

  function installPopupExperimentFetchDebugTap() {
    if (!isPopupExperimentDebugEnabled()) return;
    if (window.__umPopupExperimentFetchDebugTapInstalled) return;
    if (typeof window.fetch !== 'function') return;

    var nativeFetch = window.fetch;
    window.__umPopupExperimentFetchDebugTapInstalled = true;

    window.fetch = function (input, init) {
      var method = (init && init.method) ? String(init.method).toUpperCase() : 'GET';
      var url = getFetchDebugUrl(input);
      var isCart = isCartDebugRequest(url);

      if (isCart) {
        popupExperimentDebug('fetch_cart_request', {
          method: method,
          url: url
        });
      }

      return nativeFetch.apply(this, arguments)
        .then(function (response) {
          if (!isCart) return response;

          var status = response ? response.status : 0;
          var cloned = null;
          try {
            cloned = response.clone();
          } catch (e) {
            cloned = null;
          }

          if (!cloned) {
            popupExperimentDebug('fetch_cart_response', {
              method: method,
              url: url,
              status: status
            });
            return response;
          }

          return cloned.json()
            .then(function (payload) {
              var attrs = payload && payload.attributes ? payload.attributes : null;
              popupExperimentDebug('fetch_cart_response', {
                method: method,
                url: url,
                status: status,
                popupAttribute: attrs ? (attrs[CART_ATTRIBUTE_KEY] || '') : '',
                attrKeys: attrs ? Object.keys(attrs) : []
              });
              return response;
            })
            .catch(function () {
              popupExperimentDebug('fetch_cart_response_non_json', {
                method: method,
                url: url,
                status: status
              });
              return response;
            });
        })
        .catch(function (error) {
          if (isCart) {
            popupExperimentDebug('fetch_cart_error', {
              method: method,
              url: url,
              message: error && error.message ? error.message : String(error || '')
            });
          }
          throw error;
        });
    };
  }

  function fetchCartAttributes() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-store'
      }
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('cart_read_failed');
      return response.json();
    }).then(function (cart) {
      if (!cart || typeof cart !== 'object') return {};
      if (!cart.attributes || typeof cart.attributes !== 'object') return {};
      return cart.attributes;
    });
  }

  function updateCartAttribute(key, value) {
    if (!key) return Promise.resolve(null);
    if (window.theme && theme.cart && typeof theme.cart.updateAttribute === 'function') {
      popupExperimentDebug('cart_update_via_theme_api', {
        key: key,
        value: value
      });
      return theme.cart.updateAttribute(key, value);
    }

    popupExperimentDebug('cart_update_via_fetch_fallback', {
      key: key,
      value: value
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: (function () {
          var attrs = {};
          attrs[key] = value;
          return attrs;
        })()
      })
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('cart_update_failed');
      return response.json();
    });
  }

  var popupCartWriteInFlight = false;
  function writePopupExperimentToCart(reason) {
    if (!experimentContext || !experimentContext.eligible || !experimentContext.variant) return;
    if (popupCartWriteInFlight) return;
    popupCartWriteInFlight = true;

    var beforeAttrs = null;
    fetchCartAttributes()
      .then(function (attrs) {
        beforeAttrs = attrs || {};
        popupExperimentDebug('cart_write_before', {
          reason: reason || 'unknown',
          expected: experimentContext.variant,
          existing: beforeAttrs[CART_ATTRIBUTE_KEY] || '',
          keys: Object.keys(beforeAttrs || {})
        });
        return updateCartAttribute(CART_ATTRIBUTE_KEY, experimentContext.variant);
      })
      .then(function (responseCart) {
        var attrs = responseCart && responseCart.attributes ? responseCart.attributes : null;
        popupExperimentDebug('cart_write_response', {
          reason: reason || 'unknown',
          expected: experimentContext.variant,
          responseValue: attrs ? (attrs[CART_ATTRIBUTE_KEY] || '') : '',
          responseKeys: attrs ? Object.keys(attrs) : []
        });
        return fetchCartAttributes().catch(function () {
          return null;
        });
      })
      .then(function (afterAttrs) {
        if (!afterAttrs) return;
        popupExperimentDebug('cart_write_after', {
          reason: reason || 'unknown',
          expected: experimentContext.variant,
          finalValue: afterAttrs[CART_ATTRIBUTE_KEY] || '',
          keys: Object.keys(afterAttrs || {})
        });
      })
      .catch(function (error) {
        popupExperimentDebug('cart_write_error', {
          reason: reason || 'unknown',
          message: error && error.message ? error.message : String(error || '')
        });
      })
      .finally(function () {
        popupCartWriteInFlight = false;
      });
  }

  if (experimentContext.eligible) {
    installPopupExperimentFetchDebugTap();
    writePopupExperimentToCart('init');
    window.__umPopupExperimentDebugApi = {
      forceCartWrite: function (reason) {
        writePopupExperimentToCart(reason || 'manual_force');
      },
      getLog: function () {
        return (window.__umPopupExperimentDebugLog || []).slice();
      }
    };

    if (!window.__umPopupExperimentCartWriteBound) {
      window.__umPopupExperimentCartWriteBound = true;
      document.addEventListener('submit', function (event) {
        var target = event && event.target;
        if (!(target instanceof Element)) return;
        if (!target.matches('form[action*="/cart/add"]')) return;
        window.setTimeout(function () {
          writePopupExperimentToCart('post_add_to_cart_submit');
        }, 700);
      }, true);
    }

    if (!window.__umPopupExperimentCartDebugEventsBound) {
      window.__umPopupExperimentCartDebugEventsBound = true;
      document.addEventListener('um:cart-mode-changed', function (event) {
        popupExperimentDebug('event_cart_mode_changed', {
          detail: event && event.detail ? event.detail : null
        });
      });
      document.addEventListener('cart:build', function () {
        popupExperimentDebug('event_cart_build');
      });
      window.addEventListener('pageshow', function () {
        popupExperimentDebug('event_pageshow');
      });
    }
  }
  */

  window.initKlaviyoDelayedForm = function initKlaviyoDelayedForm(formId, delayMs, suppressMs) {
    if (!formId) return;

    // Klaviyo email-capture popups are mobile-only.
    if (window.matchMedia && window.matchMedia('(min-width: 770px)').matches) return;

    var minDelayMs = 10000;
    // Scroll gate disabled: popup should now be timer-based only.
    // Keep this for quick re-enable if needed.
    var requiredScrollPercent = 10;
    var enableScrollGate = false;
    var effectiveDelayMs = Math.max(minDelayMs, Number(delayMs) || 0);

    var key = 'klaviyo_form_suppress_until_' + formId;
    var hasOpened = false;
    var delayReady = false;
    var scrollReady = !enableScrollGate;
    var scrollListenerAttached = false;
    /* Holdout experiment assignment and eligibility telemetry disabled.
    var eligibleInExperiment = !!(experimentContext && experimentContext.eligible);
    var holdoutBlocked = !!(eligibleInExperiment && experimentContext.variant === 'holdout');

    if (eligibleInExperiment) {
      pushDataLayer('popup_experiment_assigned', {
        experiment_name: experimentContext.name,
        experiment_variant: experimentContext.variant,
        popup_eligible_segment: experimentContext.segment || 'eligible',
        detected_channel: experimentContext.detectedChannel,
        form_id: formId
      }, 'popup_assigned_' + experimentContext.name + '_' + formId);

      pushDataLayer('popup_eligible', {
        experiment_name: experimentContext.name,
        experiment_variant: experimentContext.variant,
        popup_eligible_segment: experimentContext.segment || 'eligible',
        detected_channel: experimentContext.detectedChannel,
        form_id: formId
      }, 'popup_eligible_' + experimentContext.name + '_' + formId);
    } else {
      pushDataLayer('popup_experiment_ineligible', {
        experiment_name: EXPERIMENT_NAME,
        detected_channel: experimentContext && experimentContext.detectedChannel ? experimentContext.detectedChannel : 'unknown',
        reason: experimentContext && experimentContext.reason ? experimentContext.reason : 'unknown_channel',
        form_id: formId
      }, 'popup_ineligible_' + EXPERIMENT_NAME + '_' + formId);
    }
    */

    function now() {
      return Date.now();
    }

    function getSuppressUntil() {
      try {
        var raw = localStorage.getItem(key);
        if (!raw) return 0;
        var n = parseInt(raw, 10);
        return Number.isFinite(n) ? n : 0;
      } catch (e) {
        return 0;
      }
    }

    function setSuppressUntil() {
      try {
        localStorage.setItem(key, String(now() + suppressMs));
      } catch (e) {
        // localStorage may be blocked; fail silently
      }
    }

    function canShow() {
      return now() >= getSuppressUntil();
    }

    function openForm() {
      if (hasOpened) return;
      hasOpened = true;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }

    function getScrollPercent() {
      var docEl = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop || 0;
      var scrollHeight = Math.max(
        docEl.scrollHeight || 0,
        body.scrollHeight || 0
      );
      var viewportHeight = window.innerHeight || docEl.clientHeight || 0;
      var scrollable = scrollHeight - viewportHeight;

      // If there's nothing to scroll, treat requirement as satisfied.
      if (scrollable <= 0) return 100;
      return (scrollTop / scrollable) * 100;
    }

    function detachScrollListener() {
      if (!scrollListenerAttached) return;
      window.removeEventListener('scroll', onScroll, { passive: true });
      scrollListenerAttached = false;
    }

    function maybeOpenForm() {
      if (!delayReady || !scrollReady) return;
      if (!canShow()) return;
      /* Holdout blocking disabled.
      if (holdoutBlocked) {
        detachScrollListener();
        return;
      }
      */
      openForm();
      detachScrollListener();
    }

    function onScroll() {
      if (!enableScrollGate) return;
      if (scrollReady) return;
      if (getScrollPercent() < requiredScrollPercent) return;
      scrollReady = true;
      maybeOpenForm();
    }

    window.addEventListener('klaviyoForms', function (e) {
      if (!e || !e.detail) return;
      if (e.detail.formId !== formId) return;

      var type = (e.detail.type || '').toLowerCase();
      /* Holdout experiment lifecycle telemetry disabled.
      if (type === 'open' || type === 'close' || type === 'submit') {
        pushDataLayer('klaviyo_form_' + type, Object.assign({
          form_id: formId
        }, getLifecycleExperimentPayload(experimentContext)));
      }
      */

      if (e.detail.type === 'close' || e.detail.type === 'submit') {
        setSuppressUntil();
      }
    });

    if (enableScrollGate) {
      if (getScrollPercent() >= requiredScrollPercent) {
        scrollReady = true;
      } else {
        scrollListenerAttached = true;
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    setTimeout(function () {
      delayReady = true;
      maybeOpenForm();
    }, effectiveDelayMs);
  };

  if (Array.isArray(window._umKlaviyoInitQueue) && window._umKlaviyoInitQueue.length) {
    window._umKlaviyoInitQueue.forEach(function (args) {
      if (!Array.isArray(args) || !args.length) return;
      window.initKlaviyoDelayedForm.apply(window, args);
    });
    window._umKlaviyoInitQueue = [];
  }
})();
